type GoAiguaSwitchType = {
  switched: any;
  onClick: () => void;
};

const GoAiguaSwitch: React.FC<GoAiguaSwitchType> = ({switched, onClick }) => {

  const switchStatus = () => {
    if (switched) {
      return " --on";
    } else {
      return ""; 
    }
  };

  return (
    <div
      className={"c-goaigua-switch" + switchStatus()}
      onClick={() => onClick()}
    >
      <div className={"c-goaigua-switch__push-circle" + switchStatus()}></div>
      <div className={"c-goaigua-switch__inner-circle" + switchStatus()}></div>
    </div>
  );
};

export default GoAiguaSwitch;
